/*export const BACKEND_URL = window.location.hostname === 'localhost' ? 'https://localhost:8443' :
    window.location.hostname === 'test.pinguino.com.ar' ? 'https://test.pinguino.com.ar:8443' :
        'https://pinguino.com.ar';
*/

        import { Platform, Dimensions } from 'react-native';

        let BACKEND_URL;
        
        if (Platform.OS === 'web') {
          const hostname = typeof window !== 'undefined' ? window.location.hostname : '';
        
          BACKEND_URL =
            hostname === 'localhost'
              ? 'https://localhost:8443'
              : hostname === 'test.pinguino.com.ar'
                ? 'https://test.pinguino.com.ar:8443'
                : 'https://www.pinguino.com.ar';
        } else {
          // URL para móvil (local o producción)
          BACKEND_URL = 'https://test.pinguino.com.ar:8443'; // O IP local si estás en desarrollo
        }
        
        // Función para obtener dimensiones responsivas para componentes
        export const getViewportDimensions = () => {
          const { width } = Dimensions.get('window');
          // Altura responsiva basada en el ancho de la pantalla con diferentes breakpoints
          let height;
          if (width < 576) { // Móvil pequeño
            height = 180;
          } else if (width < 768) { // Móvil/Tablet
            height = 250;
          } else if (width < 992) { // Tablet/Desktop pequeño
            height = 320;
          } else if (width < 1200) { // Desktop mediano
            height = 380;
          } else { // Desktop grande
            height = 420;
          }
          return { width, height };
        };

        export const MONTO_MINIMO_ENVIO_GRATIS = 130000;

        export const getEnvioGratisInfo = ({ total = 0, subtotal = null, montoMinimo = MONTO_MINIMO_ENVIO_GRATIS } = {}) => {
          const subtotalNumber = subtotal === null || subtotal === undefined ? NaN : parseFloat(subtotal);
          const totalNumber = parseFloat(total) || 0;
          const baseCalculo = Number.isFinite(subtotalNumber) ? subtotalNumber : totalNumber;
          const diferencia = montoMinimo - baseCalculo;
          const montoFaltante = diferencia > 0 ? diferencia : 0;
          const isGratis = montoFaltante <= 0;
          const progress = montoMinimo > 0 ? Math.min(Math.max(baseCalculo / montoMinimo, 0), 1) : 1;
          const montoFaltanteFormateado = montoFaltante.toLocaleString('es-AR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });

          return {
            montoMinimoEnvioGratis: montoMinimo,
            baseCalculo,
            diferencia,
            montoFaltante,
            montoFaltanteFormateado,
            isGratis,
            progress,
          };
        };
        
        export { BACKEND_URL };